/** @jsxImportSource @emotion/react */
import React, { useMemo, useRef, useState } from 'react';
import PropTypes, { any } from 'prop-types';
import { GlobalBtnGroup, SubTitleGroup, SubTitleLayout } from 'components/layouts/ContentLayout';
import { Button } from '@mui/material';
import CustomGrid from 'components/grids/CustomGrid';
import { t } from 'i18next';
import { IconButton } from 'components/buttons/IconSVG';
import { useTranslation } from 'react-i18next';

const IvesAtc = (props) => {
  const { t } = useTranslation();

  const gridRef = useRef();
  const [rowData, setRowData] = useState<any>([]);

  const layoutDefinition = useMemo(() => {
    return [
      {
        binding: 'bildPlntCdNm',
        header: String(t('com.label.공정', '공정')),
        align: 'center',
        minWidth: 40,
        width: 120,
      },
      {
        binding: 'custNm',
        header: String(t('com.label.설비군', '설비군')),
        align: 'center',
        minWidth: 40,
        width: 120,
      },
      {
        binding: 'custNm',
        header: String(t('com.label.투자항목', '투자항목')),
        align: 'center',
        minWidth: 40,
        width: 120,
      },
      {
        binding: 'custNm',
        header: String(t('com.label.셀 구분', '셀 구분')),
        align: 'center',
        minWidth: 40,
        width: 120,
      },
      {
        header: String(t('com.label.수량기준', '수량기준')),
        columns: [
          {
            binding: 'eltrLnNm',
            header: String(t('com.label.기준', '기준')),
            width: 120,
            isReadOnly: true,
            align: 'center',
          },
          {
            binding: 'asyLnNm',
            header: String(t('com.label.배수', '배수')),
            width: 120,
            isReadOnly: true,
            align: 'center',
          },
          {
            binding: 'asyLnNm',
            header: String(t('com.label.추가', '추가')),
            width: 120,
            isReadOnly: true,
            align: 'center',
          },
        ],
      },
      {
        binding: 'custNm',
        header: String(t('com.label.단가기준', '단가기준')),
        align: 'center',
        minWidth: 40,
        width: 120,
      },
      {
        binding: 'elmPrjNm',
        header: String(t('com.label.등록자', '등록자')),
        align: 'center',
        minWidth: 40,
        width: '*',
      },
      {
        binding: 'elmPrjId',
        header: String(t('com.label.등록일자', '등록일자')),
        align: 'center',
        minWidth: 40,
        width: 120,
      },
    ];
  }, [rowData]);

  const onInitialized = (grid) => {
    gridRef.current = grid;
  };

  return (
    <>
      <SubTitleLayout>
        <SubTitleGroup>
          <h3>{t('setup.label.투자항목', '투자항목')}</h3>
          <span className="total">
            {t('com.label.총', '총')}
            <span>{(rowData || []).length.toLocaleString()}</span>
            {t('com.label.건', '건')}
          </span>
        </SubTitleGroup>
        <GlobalBtnGroup>
          <Button css={IconButton.button} className="icoNone" disableRipple onClick={(e) => null}>
            {t('com.button.미사용', '미사용')}
          </Button>
          <Button css={IconButton.button} className="icoNone" disableRipple onClick={(e) => null}>
            {t('com.button.추가', '추가')}
          </Button>
          <Button css={IconButton.button} className="icoNone" disableRipple onClick={(e) => null}>
            {t('com.button.수정', '수정')}
          </Button>
          <Button css={IconButton.button} className="icoNone" disableRipple onClick={(e) => null}>
            {t('com.button.삭제', '삭제')}
          </Button>
          <Button css={IconButton.button} className="save" onClick={(e) => null}>
            {t('com.label.저장', '저장')}
          </Button>
        </GlobalBtnGroup>
      </SubTitleLayout>
      <CustomGrid
        layoutDefinition={layoutDefinition}
        rowData={rowData}
        isReadOnly={true}
        allowPinning={false}
        initialized={onInitialized}
        height={510}
      />
    </>
  );
};

IvesAtc.propTypes = {
  condition: any,
};

export default IvesAtc;
